/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ValidateAccessIdentifierResponse model module.
 * @module model/ValidateAccessIdentifierResponse
 * @version v1
 */
class ValidateAccessIdentifierResponse {
    /**
     * Constructs a new <code>ValidateAccessIdentifierResponse</code>.
     * @alias module:model/ValidateAccessIdentifierResponse
     * @param memberUId {String} MaxLength:100
     */
    constructor(memberUId) { 
        
        ValidateAccessIdentifierResponse.initialize(this, memberUId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, memberUId) { 
        obj['MemberUId'] = memberUId;
    }

    /**
     * Constructs a <code>ValidateAccessIdentifierResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ValidateAccessIdentifierResponse} obj Optional instance to populate.
     * @return {module:model/ValidateAccessIdentifierResponse} The populated <code>ValidateAccessIdentifierResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ValidateAccessIdentifierResponse();

            if (data.hasOwnProperty('MemberUId')) {
                obj['MemberUId'] = ApiClient.convertToType(data['MemberUId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ValidateAccessIdentifierResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ValidateAccessIdentifierResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ValidateAccessIdentifierResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['MemberUId'] && !(typeof data['MemberUId'] === 'string' || data['MemberUId'] instanceof String)) {
            throw new Error("Expected the field `MemberUId` to be a primitive type in the JSON string but got " + data['MemberUId']);
        }

        return true;
    }


}

ValidateAccessIdentifierResponse.RequiredProperties = ["MemberUId"];

/**
 * MaxLength:100
 * @member {String} MemberUId
 */
ValidateAccessIdentifierResponse.prototype['MemberUId'] = undefined;






export default ValidateAccessIdentifierResponse;

